import { locales } from "configs/i18n";
import i18next from "i18next";

i18next.addResources(locales.EN, "SHARE_CAMPAIGN", {
  TITLE: "Share Campaigns",
  CREATED: "Share campaign added succesfully",
  DELETED: "Share campaign deleted succesfully",
  EDITED: "Share campaign edited succesfully",
});
